export default __webpack_public_path__ + "static/media/marble.545c6c9d.png";